<template>
  <div>
    <AccordionCard :state="cards.inverterSerialNumberAttachments">
      <template v-slot:header>
        {{ $t('inverterSerialNumberAttachments') }}
      </template>

      <div class="flex-row">
        <div class="flex-column name">{{ $t('inverterSerialNumberAttachments') }}</div>
        <div class="flex-column select">
          <div>
            {{ $t('templateAttachments') }}:
            <AttachmentGallery
              :attachments="referenceData.reportTemplateImages[51].templateAttachments"
              :deletable="false"
              :sortByName="false"
              :showFilename="false"
            ></AttachmentGallery>
          </div>
        </div>
      </div>

      <div class="flex-row">
        <div class="flex-column name">{{ $t('inverterSerialNumberAttachments') }}</div>
        <div class="flex-column select">
          <AttachmentGallery
            :attachments="project.inverterSerialNumberAttachments"
            attachmentType="inverterSerialNumberAttachments"
            :deletable="!isBlockReadOnly"
            :hidesDeleteForGuests="!isOrganizationRoleNavigationEnabled"
            v-on:attachment-list:delete="onDeleteProjectAttachment"
            :sortByName="false"
          ></AttachmentGallery>
          <DropzoneUpload
            v-if="!isBlockReadOnly"
            class="mt-2"
            :complete="isinverterSerialNumberAttachmentsUploadComplete"
            :parentId="project.id"
            parentType="inverterSerialNumberAttachments"
            :uploadCallback="onUploadProjectAttachment"
            v-on:dropzone-upload:reset="isinverterSerialNumberAttachmentsUploadComplete = false"
            acceptedFileTypes="image/*"
          />
        </div>
      </div>
    </AccordionCard>
    <AccordionCard :state="cards.mateboxSerialNumberAttachments">
      <template v-slot:header>
        {{ $t('mateboxSerialNumberAttachments') }}
      </template>

      <div class="flex-row">
        <div class="flex-column name">{{ $t('mateboxSerialNumberAttachments') }}</div>
        <div class="flex-column select">
          <div>
            {{ $t('templateAttachments') }}:
            <AttachmentGallery
              :attachments="referenceData.reportTemplateImages[49].templateAttachments"
              :deletable="false"
              :sortByName="false"
              :showFilename="false"
            ></AttachmentGallery>
          </div>
        </div>
      </div>

      <div class="flex-row">
        <div class="flex-column name">{{ $t('mateboxSerialNumberAttachments') }}</div>
        <div class="flex-column select">
          <AttachmentGallery
            :attachments="project.mateboxSerialNumberAttachments"
            attachmentType="mateboxSerialNumberAttachments"
            :deletable="!isBlockReadOnly"
            :hidesDeleteForGuests="!isOrganizationRoleNavigationEnabled"
            v-on:attachment-list:delete="onDeleteProjectAttachment"
            :sortByName="false"
          ></AttachmentGallery>
          <DropzoneUpload
            v-if="!isBlockReadOnly"
            class="mt-2"
            :complete="ismateboxSerialNumberAttachmentsUploadComplete"
            :parentId="project.id"
            parentType="mateboxSerialNumberAttachments"
            :uploadCallback="onUploadProjectAttachment"
            v-on:dropzone-upload:reset="ismateboxSerialNumberAttachmentsUploadComplete = false"
            acceptedFileTypes="image/*"
          />
        </div>
      </div>
    </AccordionCard>
    <AccordionCard :state="cards.storageSerialNumberAttachments">
      <template v-slot:header>
        {{ $t('storageSerialNumberAttachments') }}
      </template>

      <div class="flex-row">
        <div class="flex-column name">{{ $t('storageSerialNumberAttachments') }}</div>
        <div class="flex-column select">
          <div>
            {{ $t('templateAttachments') }}:
            <AttachmentGallery
              :attachments="referenceData.reportTemplateImages[50].templateAttachments"
              :deletable="false"
              :sortByName="false"
              :showFilename="false"
            ></AttachmentGallery>
          </div>
        </div>
      </div>

      <div class="flex-row">
        <div class="flex-column name">{{ $t('storageSerialNumberAttachments') }}</div>
        <div class="flex-column select">
          <AttachmentGallery
            :attachments="project.storageSerialNumberAttachments"
            attachmentType="storageSerialNumberAttachments"
            :deletable="!isBlockReadOnly"
            :hidesDeleteForGuests="!isOrganizationRoleNavigationEnabled"
            v-on:attachment-list:delete="onDeleteProjectAttachment"
            :sortByName="false"
          ></AttachmentGallery>
          <DropzoneUpload
            v-if="!isBlockReadOnly"
            class="mt-2"
            :complete="isstorageSerialNumberAttachmentsUploadComplete"
            :parentId="project.id"
            parentType="storageSerialNumberAttachments"
            :uploadCallback="onUploadProjectAttachment"
            v-on:dropzone-upload:reset="isstorageSerialNumberAttachmentsUploadComplete = false"
            acceptedFileTypes="image/*"
          />
        </div>
      </div>
    </AccordionCard>
    <AccordionCard :state="cards.dongleSerialNumberAttachments">
      <template v-slot:header>
        {{ $t('dongleSerialNumberAttachments') }}
      </template>

      <div class="flex-row">
        <div class="flex-column name">{{ $t('dongleSerialNumberAttachments') }}</div>
        <div class="flex-column select">
          <div>
            {{ $t('templateAttachments') }}:
            <AttachmentGallery
              :attachments="referenceData.reportTemplateImages[48].templateAttachments"
              :deletable="false"
              :sortByName="false"
              :showFilename="false"
            ></AttachmentGallery>
          </div>
        </div>
      </div>

      <div class="flex-row">
        <div class="flex-column name">{{ $t('dongleSerialNumberAttachments') }}</div>
        <div class="flex-column select">
          <AttachmentGallery
            :attachments="project.dongleSerialNumberAttachments"
            attachmentType="dongleSerialNumberAttachments"
            :deletable="!isBlockReadOnly"
            :hidesDeleteForGuests="!isOrganizationRoleNavigationEnabled"
            v-on:attachment-list:delete="onDeleteProjectAttachment"
            :sortByName="false"
          ></AttachmentGallery>
          <DropzoneUpload
            v-if="!isBlockReadOnly"
            class="mt-2"
            :complete="isdongleSerialNumberAttachmentsUploadComplete"
            :parentId="project.id"
            parentType="dongleSerialNumberAttachments"
            :uploadCallback="onUploadProjectAttachment"
            v-on:dropzone-upload:reset="isdongleSerialNumberAttachmentsUploadComplete = false"
            acceptedFileTypes="image/*"
          />
        </div>
      </div>
    </AccordionCard>
    <AccordionCard :state="cards.inverterAttachments">
      <template v-slot:header>
        {{ $t('inverterAttachments') }}
      </template>

      <div class="flex-row">
        <div class="flex-column name">{{ $t('inverterAttachments') }}</div>
        <div class="flex-column select">
          <div>
            {{ $t('templateAttachments') }}:
            <AttachmentGallery
              :attachments="referenceData.reportTemplateImages[35].templateAttachments"
              :deletable="false"
              :sortByName="false"
              :showFilename="false"
            ></AttachmentGallery>
          </div>
        </div>
      </div>

      <div class="flex-row">
        <div class="flex-column name"></div>
        <div class="flex-column select">
          <AttachmentGallery
            :attachments="project.inverterAttachments"
            attachmentType="inverterAttachments"
            :deletable="!isBlockReadOnly"
            :hidesDeleteForGuests="!isOrganizationRoleNavigationEnabled"
            v-on:attachment-list:delete="onDeleteProjectAttachment"
            :sortByName="false"
          ></AttachmentGallery>
          <DropzoneUpload
            v-if="!isBlockReadOnly"
            class="mt-2"
            :complete="isinverterAttachmentsUploadComplete"
            :parentId="project.id"
            parentType="inverterAttachments"
            :uploadCallback="onUploadProjectAttachment"
            v-on:dropzone-upload:reset="isinverterAttachmentsUploadComplete = false"
            acceptedFileTypes="image/*"
          />
        </div>
      </div>
    </AccordionCard>

    <AccordionCard :state="cards.openMateboxAttachments">
      <template v-slot:header>
        {{ $t('openMateboxAttachments') }}
      </template>

      <div class="flex-row">
        <div class="flex-column name">{{ $t('openMateboxAttachments') }}</div>
        <div class="flex-column select"></div>
      </div>

      <div class="flex-row">
        <div class="flex-column name"></div>
        <div class="flex-column select">
          <AttachmentGallery
            :attachments="project.openMateboxAttachments"
            attachmentType="openMateboxAttachments"
            :deletable="!isBlockReadOnly"
            :hidesDeleteForGuests="!isOrganizationRoleNavigationEnabled"
            v-on:attachment-list:delete="onDeleteProjectAttachment"
            :sortByName="false"
          ></AttachmentGallery>
          <DropzoneUpload
            v-if="!isBlockReadOnly"
            class="mt-2"
            :complete="isOpenMateboxAttachmentsUploadComplete"
            :parentId="project.id"
            parentType="openMateboxAttachments"
            :uploadCallback="onUploadProjectAttachment"
            v-on:dropzone-upload:reset="isOpenMateboxAttachmentsUploadComplete = false"
            acceptedFileTypes="image/*"
          />
        </div>
      </div>
    </AccordionCard>

    <AccordionCard :state="cards.cableBetweenMateboxAndElectricMeterAttachments">
      <template v-slot:header>
        {{ $t('cableBetweenMateboxAndElectricMeterAttachments') }}
      </template>

      <div class="flex-row">
        <div class="flex-column name">
          {{ $t('cableBetweenMateboxAndElectricMeterAttachments') }}
        </div>
        <div class="flex-column select">
          <div>
            {{ $t('templateAttachments') }}:
            <AttachmentGallery
              :attachments="referenceData.reportTemplateImages[45].templateAttachments"
              :deletable="false"
              :sortByName="false"
              :showFilename="false"
            ></AttachmentGallery>
          </div>
        </div>
      </div>

      <div class="flex-row">
        <div class="flex-column name"></div>
        <div class="flex-column select">
          <AttachmentGallery
            :attachments="project.cableBetweenMateboxAndElectricMeterAttachments"
            attachmentType="cableBetweenMateboxAndElectricMeterAttachments"
            :deletable="!isBlockReadOnly"
            :hidesDeleteForGuests="!isOrganizationRoleNavigationEnabled"
            v-on:attachment-list:delete="onDeleteProjectAttachment"
            :sortByName="false"
          ></AttachmentGallery>
          <DropzoneUpload
            v-if="!isBlockReadOnly"
            class="mt-2"
            :complete="iscableBetweenMateboxAndElectricMeterAttachmentsUploadComplete"
            :parentId="project.id"
            parentType="cableBetweenMateboxAndElectricMeterAttachments"
            :uploadCallback="onUploadProjectAttachment"
            v-on:dropzone-upload:reset="
              iscableBetweenMateboxAndElectricMeterAttachmentsUploadComplete = false
            "
            acceptedFileTypes="image/*"
          />
        </div>
      </div>
    </AccordionCard>
    <AccordionCard :state="cards.variousBreakthroughsWithPossibleSealingsAttachments">
      <template v-slot:header>
        {{ $t('variousBreakthroughsWithPossibleSealingsAttachments') }}
      </template>

      <div class="flex-row">
        <div class="flex-column name">
          {{ $t('variousBreakthroughsWithPossibleSealingsAttachments') }}
        </div>
        <div class="flex-column select"></div>
      </div>

      <div class="flex-row">
        <div class="flex-column name"></div>
        <div class="flex-column select">
          <AttachmentGallery
            :attachments="project.variousBreakthroughsWithPossibleSealingsAttachments"
            attachmentType="variousBreakthroughsWithPossibleSealingsAttachments"
            :deletable="!isBlockReadOnly"
            :hidesDeleteForGuests="!isOrganizationRoleNavigationEnabled"
            v-on:attachment-list:delete="onDeleteProjectAttachment"
            :sortByName="false"
          ></AttachmentGallery>
          <DropzoneUpload
            v-if="!isBlockReadOnly"
            class="mt-2"
            :complete="isvariousBreakthroughsWithPossibleSealingsAttachmentsUploadComplete"
            :parentId="project.id"
            parentType="variousBreakthroughsWithPossibleSealingsAttachments"
            :uploadCallback="onUploadProjectAttachment"
            v-on:dropzone-upload:reset="
              isvariousBreakthroughsWithPossibleSealingsAttachmentsUploadComplete = false
            "
            acceptedFileTypes="image/*"
          />
        </div>
      </div>
    </AccordionCard>

    <AccordionCardOptionalInput
      :card="cards.inverterOptional"
      :project="project"
      notesType="inverterNotes"
      :attachments="project.inverterOptionalAttachments"
      attachmentType="inverterOptionalAttachments"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { AccessBlockMixin } from '@/mixins/accessBlock';
import AccordionCard from '@/components/AccordionCard';
import AccordionCardOptionalInput from '@/components/AccordionCardOptionalInput';
import AttachmentGallery from '@/components/AttachmentGallery';
import DropzoneUpload from '@/components/DropzoneUpload';

export default {
  name: 'ExistingDamage',
  components: {
    AccordionCard,
    AttachmentGallery,
    DropzoneUpload,
    AccordionCardOptionalInput,
  },
  mixins: [AccessBlockMixin],
  props: {
    project: { type: Object },
    cards: { type: Object },
    /**
     * Template images from `MobileProjectsReport` (block field, or the store getter outside the
     * block).
     */
    referenceData: { type: Object, default: () => ({ reportTemplateImages: [] }) },
  },
  data() {
    return {
      /** track Upload states for clearing dropzone preview */
      isinverterAttachmentsUploadComplete: false,
      isinverterSerialNumberAttachmentsUploadComplete: false,
      ismateboxSerialNumberAttachmentsUploadComplete: false,
      isstorageSerialNumberAttachmentsUploadComplete: false,
      isdongleSerialNumberAttachmentsUploadComplete: false,
      isCableManagementBetweenMateboxAndMeterCabinetAttachmentsUploadComplete: false,
      isvariousBreakthroughsWithPossibleSealingsAttachmentsUploadComplete: false,
      isOpenMateboxAttachmentsUploadComplete: false,
      iscableBetweenMateboxAndElectricMeterAttachmentsUploadComplete: false,
    };
  },
  computed: {
    ...mapGetters(['getEnumValues']),
    ...mapGetters('auth', ['isOrganizationRoleNavigationEnabled']),
    isPitchedRoof() {
      return this.project.measurement && this.project.measurement.roofType === 'PITCHED_ROOF';
    },
  },

  methods: {
    ...mapActions(['uploadProjectAttachment', 'deleteProjectAttachment']),

    async onUploadProjectAttachment(payload) {
      await this.uploadProjectAttachment(payload);
    },

    async onDeleteProjectAttachment(event) {
      await this.deleteProjectAttachment({
        projectId: this.project.id,
        attachmentId: event.attachmentId,
        attachmentType: event.attachmentType,
      });
    },
  },
  async mounted() {
    // after upload is complete emit event to clear dropzone preview
    this.$store.subscribeAction({
      after: (action, state) => {
        if (action.type === 'uploadProjectAttachment') {
          this.isinverterAttachmentsUploadComplete = true;
          this.isinverterSerialNumberAttachmentsUploadComplete = true;
          this.ismateboxSerialNumberAttachmentsUploadComplete = true;
          this.isstorageSerialNumberAttachmentsUploadComplete = true;
          this.isdongleSerialNumberAttachmentsUploadComplete = true;
          this.isCableManagementBetweenMateboxAndMeterCabinetAttachmentsUploadComplete = true;
          this.isvariousBreakthroughsWithPossibleSealingsAttachmentsUploadComplete = true;
          this.isOpenMateboxAttachmentsUploadComplete = true;
          this.iscableBetweenMateboxAndElectricMeterAttachmentsUploadComplete = true;
        }
      },
    });
  },
};
</script>

<style lang="scss" scoped></style>
